export default ({ ids, data, basePath, children, ...rest }) => children({ ids, data, basePath, ...rest });
